module.exports = __webpack_public_path__ + "static/img/9.416cf95a.png";